import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import userStore from "../zustand/userStore";
import { BASE_URL } from "../configs/WebServiceUrl";

const ROWS_PER_PAGE = 10;

export default function MyReferrals() {
  const userData = userStore((state) => state.user);
  const parentId = userData?.admin_id;

  const [loading, setLoading] = useState(false);
  const [referrals, setReferrals] = useState([]);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (!parentId) return;

    const fetchReferrals = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${BASE_URL}/api/profile/referrals/${parentId}`,
        );

        if (res.data?.success) {
          setReferrals(res.data.data || []);
        } else {
          setReferrals([]);
        }
      } catch (err) {
        console.error("❌ Failed to fetch referrals", err);
        setError("Failed to load referrals");
      } finally {
        setLoading(false);
      }
    };

    fetchReferrals();
  }, [parentId]);

  const totalPages = Math.ceil(referrals.length / ROWS_PER_PAGE);

  const paginatedData = useMemo(() => {
    const start = (page - 1) * ROWS_PER_PAGE;
    return referrals.slice(start, start + ROWS_PER_PAGE);
  }, [referrals, page]);

  if (loading) return <p>Loading referrals...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (!referrals.length) return <p>No referrals found</p>;

  return (
    <div>
      {/* ===== Table ===== */}
      <div style={{ overflowX: "auto" }}>
        <table
          className="table table-sm table-bordered table-hover"
          style={{
            fontSize: "12px",
            lineHeight: "1.2",
          }}
        >
          <thead className="table-light">
            <tr style={{ height: "20px" }}>
              <th style={{ padding: "4px 6px" }}>S.No</th>
              <th style={{ padding: "4px 6px" }}>Name</th>
              <th style={{ padding: "4px 6px" }}>School Name</th>
              <th style={{ padding: "4px 6px" }}>Email</th>
              <th style={{ padding: "4px 6px" }}>Mobile Number</th>
              {/* <th style={{ padding: "4px 6px" }}>Role</th> */}
              <th style={{ padding: "4px 6px" }}>Account Type</th>
              <th style={{ padding: "4px 6px" }}>Registered Date</th>
            </tr>
          </thead>

          <tbody>
            {paginatedData.map((item, index) => (
              <tr key={item.referral_id} style={{ height: "20px" }}>
                <td style={{ padding: "3px 6px" }}>
                  {(page - 1) * ROWS_PER_PAGE + index + 1}
                </td>
                <td style={{ padding: "3px 6px" }}>{item.admin_name || "-"}</td>
                <td style={{ padding: "3px 6px" }}>
                  {item.school_name || "-"}
                </td>
                <td style={{ padding: "3px 6px" }}>{item.email || "-"}</td>
                <td style={{ padding: "3px 6px" }}>
                  {item.contact_number || "-"}
                </td>
                {/* <td style={{ padding: "3px 6px" }}>{item.role || "-"}</td> */}
                <td style={{ padding: "3px 6px" }}>
                  {item.account_type || "-"}
                </td>
                <td style={{ padding: "3px 6px" }}>
                  {item.registered_on
                    ? new Date(item.registered_on)
                        .toLocaleDateString("en-GB")
                        .replace(/\//g, "-")
                    : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ===== Pagination ===== */}
      {totalPages > 1 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "6px",
            marginTop: "10px",
            alignItems: "center",
          }}
        >
          {/* Prev */}
          <button
            className="btn btn-sm btn-outline-secondary"
            disabled={page === 1}
            onClick={() => setPage((p) => p - 1)}
          >
            ◀
          </button>

          {/* Page Numbers */}
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
            <button
              key={p}
              className={`btn btn-sm ${
                p === page ? "btn-primary" : "btn-outline-secondary"
              }`}
              onClick={() => setPage(p)}
            >
              {p}
            </button>
          ))}

          {/* Next */}
          <button
            className="btn btn-sm btn-outline-secondary"
            disabled={page === totalPages}
            onClick={() => setPage((p) => p + 1)}
          >
            ▶
          </button>
        </div>
      )}
    </div>
  );
}
